import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail',
  standalone: true
})
export class MaskEmailPipe implements PipeTransform {
  transform(email: string): string {
    // Return the original value if the input is empty or not a valid email
    if (!email || !email.includes('@')) {
      return email;
    }

    // Split the email into username and domain
    const [username, domain] = email.split('@');

    // Avoid masking if the username or domain is too short
    if (username.length < 2 || domain.length < 3) {
      return email;
    }

    // Mask the username (keep only the first character visible)
    const maskedUsername = username[0] + '*'.repeat(username.length - 1);

    // Split the domain into name and TLD (e.g., "example.com" -> "example" + ".com")
    const domainParts = domain.split('.');
    if (domainParts.length < 2) {
      return email; // Return original email if the domain is invalid
    }

    const domainName = domainParts[0];
    const tld = domainParts.slice(1).join('.'); // Preserve the TLD

    // Mask the domain name (keep only the first character visible)
    const maskedDomain = domainName[0] + '*'.repeat(domainName.length - 1);

    // Return the masked email
    return `${maskedUsername}@${maskedDomain}.${tld}`;
  }
}
